import { render, staticRenderFns } from "./apostilleFlow.vue?vue&type=template&id=6de995e9&"
import script from "./apostilleFlow.vue?vue&type=script&lang=js&"
export * from "./apostilleFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports